import { useApi } from '../../hooks/useApi';

export const useFeedbackSubmission = () => {
  const { fetchWithSession } = useApi();

  const submitFeedback = async (
    traceId: string, 
    sessionId: string,
    score: number, 
    comment?: string,
    content?: string,
    question?: string
  ) => {
    const response = await fetchWithSession(`/api/v1/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        trace_id: traceId,
        session_id: sessionId,
        score,
        comment,
        ai_answer: content,
        question: question
      }),
    });

    return response;
  };

  return { submitFeedback };
};